import React, { useContext, useEffect, useState } from "react";
import { Image, Button, Row, Container } from "react-bootstrap";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import parse from "react-html-parser";

const closeBtnFocus = (event) => {
  //    if (window && window.parent && keyCode==9) {
  //     window.parent.postMessage("closeBtnFocus", "*");
  //    }

  if (event.shiftKey && event.keyCode === 9) {
    window.parent.postMessage("agreement", "*");
  } else if (event.keyCode === 9) {
    window.parent.postMessage("closeBtnFocus", "*");
  }
};
const MppModalFooter = (props) => {

  const [isSetPayIn4Product, setIsSetPayIn4Product] = useState(false)

  const {
    flowType,
    applyPrequalPendingStatus,
    isWideWrapper,
    brandings: {
      mppPrimaryColors,
      preQual,
      prequalifyButtonText,
      prequalifyButtonTextMultiProduct,
      applyButtonText,
      footerLogo,
      onlineUsageAgreement,
      onlinePrivacyPolicy,
      accessibility
    },
    openApplyHandler,
    isSpinnerDisplayed,
    offers,
    queryValues: { d2dFlow },
    footerLinkColor,
    ProductDetails,
    mppFromEmail,
    applyDisabled,
    payInFourProductConfigured,
    shoppingCartimg,
    applyDisableButtonText,
    cartInfoMsg,
    merchantWebsiteURL,
    mppConfig,
    merchantName,
  } =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useContext(ThemeContext); 

    const isCareCredit = merchantName?.toLowerCase() === "carecredit";

  const { setSuccessPageMppApplication, errorPageMppApplication } = props;
  const { mppApplicationLinkFlag, buttonTextGetapplicationLink, quickScreenApproved } = mppConfig || {};
  const isPending = applyPrequalPendingStatus === "Pending";
  const isSetPayIn4Alone =
    offers.length === 1 && offers[0].offerType === "SetPAYIn4" && !ProductDetails;
  const prequalButtonTextToDisplay = payInFourProductConfigured
    ? prequalifyButtonTextMultiProduct
    : prequalifyButtonText;

  const handleProductDetailsPrequalText = (details) => {
      if(details && details.length == 1 && details[0].clientProductCode ==="150"){
        setIsSetPayIn4Product(true)
      }
  }

  const setWindowHeight = () => {
    document.documentElement.style.setProperty(
      "--screen-height",
      window.innerHeight + "px"
    );
    let resizevh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${resizevh}px`);

    if (
      ["CHECKOUT"].includes(flowType) || 
      (!mppApplicationLinkFlag && !["CHECKOUT"].includes(flowType) && isSetPayIn4Alone) ||
      errorPageMppApplication || (mppApplicationLinkFlag && ProductDetails)
    ) {
      document.documentElement.style.setProperty(
        "--mpp-model-body-height",
        applyDisabled === "Y" ? '280px' : '135px'
      );
    } else {
      document.documentElement.style.setProperty(
        "--mpp-model-body-height",
        applyDisabled === "Y" ? '280px' : '205px'
      );
    }
  };

  useEffect(() => {
    setWindowHeight();
    handleProductDetailsPrequalText(ProductDetails?.details);
  }, [ProductDetails]);

  const handleSubmit = () => {
    if (d2dFlow !== "Y") {
      window.parent.postMessage("Close", "*");
    } else {
      window.location = merchantWebsiteURL
    }
  }

  const handleApplicationLink = () =>{
    console.log("clicked application link btn");
    setSuccessPageMppApplication(true);
    document.documentElement.style.setProperty("--mpp-model-body-height",'135px');
    document.getElementsByClassName("apply-preqal-Btn")[0].style.display = "none";
  }

  return (
    <React.Fragment>
      <div className="modal-footer">
        <Container fluid={true} style={{ margin: "0px" }}>
          {!isPending &&
            flowType !== "CHECKOUT" &&
            !isSetPayIn4Alone &&
            !ProductDetails && applyDisabled !== "Y" && 
            !mppApplicationLinkFlag && !quickScreenApproved && (
              <Row className={mppFromEmail ? "email-apply-prequal-btn" : "apply-preqal-Btn"}>
                <Button
                  className={ isWideWrapper ? "btn btnPrimary prequaliBtn syfClickEvent d2dPrequalBtn" : "btn btnPrimary prequaliBtn syfClickEvent" }
                  disabled={isSpinnerDisplayed === "block" ? "disabled" : ""}
                  tabIndex="0"
                  onClick={openApplyHandler}
                  data-type="body" 
                  data-object="button"
                  data-reason={preQual === "true"
                    ? prequalButtonTextToDisplay?.toLowerCase()
                    : applyButtonText?.toLowerCase()}
                  style={{
                    backgroundColor: mppPrimaryColors,
                    borderColor: mppPrimaryColors,
                  }}
                >
                  {preQual === "true" ? prequalButtonTextToDisplay : applyButtonText}
                </Button>
              </Row>
            )}

          {ProductDetails && !isSetPayIn4Product && 
          !isSetPayIn4Alone && !mppApplicationLinkFlag && applyDisabled !== "Y" && (
            <Row className={mppFromEmail ? "email-apply-prequal-btn" : "apply-preqal-Btn"}>
                <Button
                  className="btn btnPrimary prequaliBtn syfClickEvent"
                  disabled={isSpinnerDisplayed === "block" ? "disabled" : ""}
                  tabIndex="0"
                  onClick={openApplyHandler}
                  data-type="body" 
                  data-object="button"
                  data-reason={prequalButtonTextToDisplay?.toLowerCase()}
                  style={{
                    backgroundColor: mppPrimaryColors,
                    borderColor: mppPrimaryColors,
                  }}
                >
                  {prequalButtonTextToDisplay}
                </Button>
            </Row>
          )}

          {
            applyDisabled === "Y" && !mppApplicationLinkFlag  &&
            !quickScreenApproved && (
              <Row className="shop-now-footer">
                <div className="cart-section">
                  <div>
                    <img src={shoppingCartimg} alt="" />
                  </div>
                  <div>
                    {parse(cartInfoMsg)}
                  </div>
                </div>
                <Button
                  className="btn btnPrimary prequaliBtn syfClickEvent"
                  tabIndex="0"
                  style={{
                    backgroundColor: mppPrimaryColors,
                    borderColor: mppPrimaryColors,
                  }}
                  data-type="body" 
                  data-object="button"
                  data-reason= {applyDisableButtonText?.toLowerCase()}
                  onClick={handleSubmit}
                >
                  {applyDisableButtonText}
                </Button>
              </Row>
            )
          }

          {
            mppApplicationLinkFlag && !errorPageMppApplication && !ProductDetails &&
            !quickScreenApproved &&(
              <Row className="apply-preqal-Btn">
                <Button
                  className="btn btnPrimary prequaliBtn syfClickEvent"
                  tabIndex="0"
                  style={{
                    backgroundColor: mppPrimaryColors,
                    borderColor: mppPrimaryColors,
                  }}
                  data-type="body" 
                  data-object="button"
                  data-reason= {buttonTextGetapplicationLink?.toLowerCase()}
                  onClick={handleApplicationLink}
                >
                  {buttonTextGetapplicationLink}
                </Button>
              </Row>
            )
          }


          <div className="syncImg">
            <div className="pl-0 imageContainer">
              <Image
                variant="top"
                src={footerLogo}
                alt="Synchrony Logo"
                style={
                  isCareCredit ? { width: "117px", height: "16px"} : {}
                }
              />
            </div>
            <div className="pl-0 pr-0  text-end refeContainer">
              <p className="footerText">
                <a
                  href={onlineUsageAgreement}
                  className="color3 syfClickEvent"
                  target="_blank"
                  data-type="footer"
                  data-object="link"
                  title="opens in a new window"
                  style={{ color: footerLinkColor }}
                  data-reason="Web Site Usage Agreement"
                  id="agreement"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Usage Agreement
                </a>

                <span className="removebar" aria-hidden="true"> | </span>

                <a
                  href={onlinePrivacyPolicy}
                  style={{ color: footerLinkColor }}
                  className="color3 syfClickEvent"
                  id="onlinePrivacyPolicy"
                  target="_blank"
                  data-type="footer"
                  data-object="link"
                  title="opens in a new window"
                  data-reason="Privacy Policy"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Online Privacy Policy
                </a>
                <span className="removebar" aria-hidden="true"> | </span>
                <a
                  href={accessibility}
                  style={{ color: footerLinkColor }}
                  className="color3 syfClickEvent"
                  id="accessibility"
                  target="_blank"
                  onKeyDown={closeBtnFocus}
                  data-type="footer"
                  data-object="link"
                  data-reason="Accessibility"
                  title="opens in a new window"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Accessibility
                </a>
                <span className="removebar" aria-hidden="true"> | </span>
                <a
                  href={onlinePrivacyPolicy + "#ca-dnss"}
                  style={{ color: footerLinkColor }}
                  className="color3 syfClickEvent"
                  id="ca_residents"
                  target="_blank"
                  onKeyDown={closeBtnFocus}
                  data-type="footer"
                  data-object="link"
                  data-reason="CA Residents - Do Not Sell/Share"
                  title="opens in a new window"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  CA Residents - Do Not Sell/Share
                </a>
              </p>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default MppModalFooter;
